import { render, staticRenderFns } from "./UtilMenu.vue?vue&type=template&id=6f087efa&scoped=true&"
import script from "./UtilMenu.vue?vue&type=script&lang=js&"
export * from "./UtilMenu.vue?vue&type=script&lang=js&"
import style0 from "./UtilMenu.vue?vue&type=style&index=0&id=6f087efa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f087efa",
  null
  
)

export default component.exports